import type { AuthSystemDomainSchemaWithId } from '@iconik-io/iconik-api/src/services/auth';

export const SYSTEM_DOMAIN_STATUSES = {
  ACTIVE: 'ACTIVE',
  FROZEN: 'FROZEN',
  DEACTIVATED: 'DEACTIVATED',
  WARNING: 'WARNING',
} as const;

export type SystemDomainStatus = NonNullable<
  AuthSystemDomainSchemaWithId['status']
>;

const systemDomainStatusSet: ReadonlySet<string> = new Set(
  Object.values(SYSTEM_DOMAIN_STATUSES),
);

export const isSystemDomainStatus = (
  value: string,
): value is SystemDomainStatus => systemDomainStatusSet.has(value);

export type SystemDomainStatusOption = {
  label: string;
  value: SystemDomainStatus;
  bsStyle: 'success' | 'danger' | 'warning';
};

export const SYSTEM_DOMAIN_STATUS_OPTIONS: SystemDomainStatusOption[] = [
  { label: 'Active', value: SYSTEM_DOMAIN_STATUSES.ACTIVE, bsStyle: 'success' },
  {
    label: 'Deactivated',
    value: SYSTEM_DOMAIN_STATUSES.DEACTIVATED,
    bsStyle: 'danger',
  },
  { label: 'Frozen', value: SYSTEM_DOMAIN_STATUSES.FROZEN, bsStyle: 'warning' },
  {
    label: 'Warning',
    value: SYSTEM_DOMAIN_STATUSES.WARNING,
    bsStyle: 'warning',
  },
];

// Types of system domains accounts
export const SYSTEM_DOMAIN_TYPES = {
  TRIAL: 'TRIAL',
  CUSTOMER: 'CUSTOMER',
  PARTNER: 'PARTNER',
  INTERNAL: 'INTERNAL',
} as const;

export type SystemDomainType = keyof typeof SYSTEM_DOMAIN_TYPES;

const systemDomainTypeSet: ReadonlySet<string> = new Set(
  Object.values(SYSTEM_DOMAIN_TYPES),
);

export const isSystemDomainType = (value: string): value is SystemDomainType =>
  systemDomainTypeSet.has(value);

export const SYSTEM_DOMAIN_TYPE_OPTIONS = [
  { label: 'Trial', value: SYSTEM_DOMAIN_TYPES.TRIAL },
  { label: 'Customer', value: SYSTEM_DOMAIN_TYPES.CUSTOMER },
  { label: 'Partner', value: SYSTEM_DOMAIN_TYPES.PARTNER },
  { label: 'Internal', value: SYSTEM_DOMAIN_TYPES.INTERNAL },
];

export const SYSTEM_DOMAIN_BILLING_TIERS = {
  PAYGO: 'PAYGO',
  PRO: 'PRO',
  ENTERPRISE: 'ENTERPRISE',
  PRO_LEGACY_2025: 'PRO_LEGACY_2025',
  ENTERPRISE_LEGACY_2025: 'ENTERPRISE_LEGACY_2025',
} as const;

export type SystemDomainBillingTier = keyof typeof SYSTEM_DOMAIN_BILLING_TIERS;

export const SYSTEM_DOMAIN_BILLING_TIERS_OPTIONS = [
  { label: 'Pay as you go', value: 'PAYGO' },
  { label: 'Pro', value: 'PRO' },
  { label: 'Enterprise', value: 'ENTERPRISE' },
];
